import { render } from "./Registration.vue?vue&type=template&id=0991a802&scoped=true"
import script from "./Registration.vue?vue&type=script&lang=js"
export * from "./Registration.vue?vue&type=script&lang=js"

import "./Registration.vue?vue&type=style&index=0&id=0991a802&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-0991a802"

export default script